
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { BrandModel } from './Entities.GormCrm.Brand';
import { CompanyModel } from './Entities.GormCrm.Company';
import { LegalCaseProductPlanModel } from './Entities.GormCrm.LegalCaseProductPlan';
import { LegalCaseStatus } from 'enums/LegalCaseStatus';
import { Model, ModelProperty } from 'models/Model';


export class LegalCaseModel extends Model<LegalCaseModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'guid', languageString: 'legalCase.property.id', isHidden: true },
		{ name: 'number', type: 'number', languageString: 'legalCase.property.number' },
		{ name: 'companyId', type: 'guid', languageString: 'legalCase.property.companyId' },
		{ name: 'createdByUserId', type: 'guid', languageString: 'legalCase.property.createdByUserId' },
		{ name: 'dueDate', type: 'Date', languageString: 'legalCase.property.dueDate' },
		{ name: 'created', type: 'Date', languageString: 'legalCase.property.created', isHidden: true },
		{ name: 'comment', type: 'string', languageString: 'legalCase.property.comment' },
		{ name: 'brandId', type: 'guid', languageString: 'legalCase.property.brandId' },
		{ name: 'brand', type: 'BrandModel', languageString: 'legalCase.property.brand', isHidden: true, isObject: true, new: () => { return new BrandModel }, properties: () => { return BrandModel.classProperties } },
		{ name: 'company', type: 'CompanyModel', languageString: 'legalCase.property.company', isHidden: true, isObject: true, new: () => { return new CompanyModel }, properties: () => { return CompanyModel.classProperties } },
		{ name: 'legalCaseProductPlans', type: 'LegalCaseProductPlanModel[]', languageString: 'legalCase.property.legalCaseProductPlans', isHidden: true, isArray: true, isObject: true, new: () => { return new LegalCaseProductPlanModel }, properties: () => { return LegalCaseProductPlanModel.classProperties } },
		{ name: 'status', type: 'LegalCaseStatus', languageString: 'legalCase.property.status' }
	];
	[key: string]: any;
	
	public id?: string;
	public number: number;
	public companyId?: string;
	public createdByUserId?: string;
	public dueDate?: Date;
	public created?: Date;
	public comment: string;
	public brandId?: string;
	public brand?: BrandModel;
	public company?: CompanyModel;
	public legalCaseProductPlans: LegalCaseProductPlanModel[];
	public status: LegalCaseStatus;
    
	constructor(){
		super();
		this.id = undefined;
		this.number = 0;
		this.companyId = undefined;
		this.createdByUserId = undefined;
		this.dueDate = undefined;
		this.created = undefined;
		this.comment = '';
		this.brandId = undefined;
		this.brand = undefined;
		this.company = undefined;
		this.legalCaseProductPlans = [];
		this.status = 0;
		
	}
	getProperties(){
		return LegalCaseModel.classProperties;
	}
}

